"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateRootCauseOrCategoryByIdAction = exports.reducer = exports.getSortedIssueRootCauseCategories = exports.getRootCausesFromRootCauseCategory = exports.getIssueRootCausesEntitiesMap = exports.getIsLoadingIssueRootCauses = exports.getAllGroupedRootCauses = exports.getActiveGroupedRootCauses = exports.fetchIssueRootCausesAction = exports.deleteRootCauseOrCategoryByIdAction = exports.STATE_KEY = void 0;
var _map = _interopRequireDefault(require("lodash/map"));
var _toolkit = require("@reduxjs/toolkit");
var _sortingHelpers = require("../../../utils/data/sortingHelpers");
var _fetchHelpers = require("../fetchHelpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// children ids (which represent issue root causes) are sorted by title
const flattenIssueRootCauses = entitiesList => entitiesList.reduce((acc, category) => {
  const {
    rootCauses,
    ...extendedCategory
  } = {
    ...category
  };
  acc[category.id] = {
    ...extendedCategory,
    childrenIds: rootCauses ? rootCauses.sort(_sortingHelpers.localeCompareByTitle).map(rootCause => {
      acc[rootCause.id] = {
        ...rootCause,
        parentId: category.id
      };
      return rootCause.id;
    }) : []
  };
  return acc;
}, {});
const initialState = {
  [_fetchHelpers.STATUS_KEY]: _fetchHelpers.FetchStatus.Initial,
  rootCauseCategoryIds: [],
  entitiesMap: {},
  pendingUpdatesMap: {}
};
const issueRootCausesSlice = (0, _toolkit.createSlice)({
  name: "rootCauses",
  initialState,
  reducers: {
    rootCausesFetchStart(state) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Loading;
    },
    rootCausesFetchSuccess(state, action) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Success;
      state.rootCauseCategoryIds = (0, _map.default)(action.payload, "id");
      state.entitiesMap = flattenIssueRootCauses(action.payload);
      // since this will be returning the most up-to-date data we can
      // safely clear the pending updates.
      state.pendingUpdatesMap = {};
    },
    rootCausesFetchError(state) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Error;
    },
    rootCauseOrCategoryUpdateByIdStart(state, action) {
      state.pendingUpdatesMap = {
        ...state.pendingUpdatesMap,
        [action.payload.id]: action.payload.entityChanges
      };
    },
    rootCauseOrCategoryUpdateByIdFailure(state, action) {
      delete state.pendingUpdatesMap[action.payload.id];
    }
  }
});
const {
  rootCausesFetchStart,
  rootCausesFetchSuccess,
  rootCausesFetchError,
  rootCauseOrCategoryUpdateByIdStart,
  rootCauseOrCategoryUpdateByIdFailure
} = issueRootCausesSlice.actions;
const fetchIssueRootCausesAction = () => (dispatch, getState, _ref) => {
  let {
    sdk
  } = _ref;
  dispatch(rootCausesFetchStart());
  sdk.IssueRootCauses.getAll().then(response => {
    dispatch(rootCausesFetchSuccess(response.results));
  }, () => {
    dispatch(rootCausesFetchError());
  });
};
exports.fetchIssueRootCausesAction = fetchIssueRootCausesAction;
const reducer = exports.reducer = issueRootCausesSlice.reducer;
const STATE_KEY = exports.STATE_KEY = issueRootCausesSlice.name;
const getIssueRootCausesState = state => state[STATE_KEY];
const getIssueRootCausesEntitiesMap = exports.getIssueRootCausesEntitiesMap = (0, _toolkit.createSelector)(getIssueRootCausesState, issueRootCausesState => {
  const entitiesMap = {
    ...issueRootCausesState.entitiesMap
  };
  Object.keys(issueRootCausesState.pendingUpdatesMap).forEach(entityId => {
    // typescript is very worried that category data will be assigned to root causes
    // or vice-versa.
    // It's clearer to ignore that concern here than to try to get the types to model it.
    // @ts-ignore
    entitiesMap[entityId] = {
      ...entitiesMap[entityId],
      ...issueRootCausesState.pendingUpdatesMap[entityId]
    };
  });
  return entitiesMap;
});
const getIsLoadingIssueRootCauses = exports.getIsLoadingIssueRootCauses = (0, _toolkit.createSelector)(getIssueRootCausesState, _fetchHelpers.isLoading);

// this selector filters out the root cause entities that are not categories
const getSortedIssueRootCauseCategories = exports.getSortedIssueRootCauseCategories = (0, _toolkit.createSelector)(state => getIssueRootCausesState(state).rootCauseCategoryIds, getIssueRootCausesEntitiesMap, (orderedRootCauseIds, rootCauseEntitiesMap) => {
  return orderedRootCauseIds.filter(rootCauseCategoryId => {
    return rootCauseEntitiesMap[rootCauseCategoryId] && !rootCauseEntitiesMap[rootCauseCategoryId].rootCauseCategoryId;
  }).map(rootCauseCategoryId => {
    return rootCauseEntitiesMap[rootCauseCategoryId];
  }).sort(_sortingHelpers.localeCompareByTitle);
});
const getRootCausesFromRootCauseCategory = (extendedRootCauseCategory, rootCauseEntitiesMap) => extendedRootCauseCategory.childrenIds.map(rootCauseId => rootCauseEntitiesMap[rootCauseId]).filter(rootCause => !!rootCause);
exports.getRootCausesFromRootCauseCategory = getRootCausesFromRootCauseCategory;
const getAllGroupedRootCauses = exports.getAllGroupedRootCauses = (0, _toolkit.createSelector)(getSortedIssueRootCauseCategories, getIssueRootCausesEntitiesMap, (sortedIssueRootCauseCategories, rootCausesEntitiesMap) => {
  return sortedIssueRootCauseCategories.map(rootCauseCategory => ({
    ...rootCauseCategory,
    rootCauses: getRootCausesFromRootCauseCategory(rootCauseCategory, rootCausesEntitiesMap)
  }));
});
const getActiveGroupedRootCauses = exports.getActiveGroupedRootCauses = (0, _toolkit.createSelector)(getSortedIssueRootCauseCategories, getIssueRootCausesEntitiesMap, (sortedIssueRootCauseCategories, rootCausesEntitiesMap) => {
  return sortedIssueRootCauseCategories.filter(rootCauseCategory => rootCauseCategory.isActive).map(rootCauseCategory => ({
    ...rootCauseCategory,
    rootCauses: getRootCausesFromRootCauseCategory(rootCauseCategory, rootCausesEntitiesMap).filter(rootCause => rootCause.isActive)
  }));
});
const updateRootCauseOrCategoryByIdAction = _ref2 => {
  let {
    id,
    entityChanges,
    isCategory,
    onSuccess,
    onFailure
  } = _ref2;
  return async (dispatch, getState, _ref3) => {
    let {
      sdk
    } = _ref3;
    dispatch(rootCauseOrCategoryUpdateByIdStart({
      id,
      entityChanges
    }));
    const sdkUpdateFn = isCategory ? sdk.IssueRootCauses.Categories.update : sdk.IssueRootCauses.update;
    try {
      await sdkUpdateFn(id, entityChanges);
    } catch (error) {
      dispatch(rootCauseOrCategoryUpdateByIdFailure({
        id
      }));
      onFailure && onFailure(error);
      return;
    }
    onSuccess && onSuccess();
    // instead of processing each change individually,
    // we make sure to fetch all types + categories after every change.
    // This reduces the risk of stale data, and ensures
    // that reordering (and scrolling to the correct row)
    // occurs on a title change.
    dispatch(fetchIssueRootCausesAction());
  };
};
exports.updateRootCauseOrCategoryByIdAction = updateRootCauseOrCategoryByIdAction;
const deleteRootCauseOrCategoryByIdAction = _ref4 => {
  let {
    id,
    isCategory,
    onSuccess,
    onFailure
  } = _ref4;
  return async (dispatch, getState, _ref5) => {
    let {
      sdk
    } = _ref5;
    const sdkDeleteFn = isCategory ? sdk.IssueRootCauses.Categories.delete : sdk.IssueRootCauses.delete;
    try {
      await sdkDeleteFn(id);
      onSuccess && onSuccess();
    } catch (error) {
      onFailure && onFailure(error);
      return;
    }
    // following the same pattern as the updates, we fetch all after this change

    dispatch(fetchIssueRootCausesAction());
  };
};
exports.deleteRootCauseOrCategoryByIdAction = deleteRootCauseOrCategoryByIdAction;
//# sourceMappingURL=issueRootCauses.js.map